/* eslint-disable global-require */ // The top-level (parent) route
const routes = {
    path: '',
    // Keep in mind, routes are evaluated in order
    children: [
        // without auth only
        {
            path: '/aid',
            children: [
                {
                    name: 'sign-in-old',
                    path: '',
                    load: ()=>import(/* webpackChunkName: 'account' */ './sign-in')
                },
                {
                    name: 'confirm-guardian-email-mock',
                    path: '/confirm-guardian-email-mock',
                    load: ()=>import(/* webpackChunkName: 'account-setup' */ './confirm-guardian-email-mock')
                }
            ],
            async action ({ next }) {
                // Execute each child route until one of them return the result
                const route = await next();
                return route;
            }
        },
        // with auth
        {
            path: '/aid',
            children: [
                {
                    name: 'app-catalog',
                    path: '/app-catalog',
                    load: ()=>import(/* webpackChunkName: 'account' */ './app-catalog')
                },
                {
                    name: 'switch-identity',
                    path: '/switch-identity',
                    load: ()=>import(/* webpackChunkName: 'account' */ './switch-identity')
                },
                {
                    name: 'change-password',
                    path: '/change-password',
                    load: ()=>import(/* webpackChunkName: 'change-password' */ './change-password')
                },
                {
                    name: 'delete-account',
                    path: '/delete-account',
                    load: ()=>import(/* webpackChunkName: 'delete-account' */ './delete-account')
                },
                {
                    name: 'invitation',
                    path: '/invitation',
                    load: ()=>import(/* webpackChunkName: 'invitation' */ './invitation')
                },
                {
                    name: 'set-information',
                    path: '/set-information',
                    load: ()=>import(/* webpackChunkName: 'account-setup' */ './set-information')
                },
                {
                    name: 'edit-information',
                    path: '/edit-information',
                    load: ()=>import(/* webpackChunkName: 'account-setup' */ './edit-information')
                },
                {
                    name: 'add-profile',
                    path: '/add-profile',
                    load: ()=>import(/* webpackChunkName: 'personal-information' */ './add-profile')
                },
                {
                    name: 'personal-information',
                    path: '/personal-information',
                    load: ()=>import(/* webpackChunkName: 'personal-information' */ './personal-information')
                },
                {
                    name: 'provider-change-password',
                    path: '/provider/:identityProviderKeySlug/change-password',
                    load: ()=>import(/* webpackChunkName: 'personal-information' */ './provider-change-password')
                },
                {
                    name: 'provider-reset-password',
                    path: '/provider/:identityProviderKeySlug/reset-password',
                    load: ()=>import(/* webpackChunkName: 'personal-information' */ './provider-reset-password')
                },
                {
                    name: 'profile-details',
                    path: '/profile/:countryCode/:scopeSlug',
                    load: ()=>import(/* webpackChunkName: 'personal-information' */ './profile-details')
                },
                {
                    name: 'organization-create',
                    path: '/organization-create',
                    load: ()=>import(/* webpackChunkName: 'organization-memberships' */ './organization-create')
                },
                {
                    name: 'organization-memberships-join',
                    path: '/organization-memberships#join',
                    load: ()=>import(/* webpackChunkName: 'organization-memberships' */ './organization-memberships')
                },
                {
                    name: 'organization-memberships',
                    path: '/organization-memberships',
                    load: ()=>import(/* webpackChunkName: 'organization-memberships' */ './organization-memberships')
                },
                {
                    name: 'organization-membership-details',
                    path: '/organization-membership/:organizationUID',
                    load: ()=>import(/* webpackChunkName: 'organization-memberships' */ './organization-membership-details')
                }
            ],
            async action ({ next }) {
                // Execute each child route until one of them return the result
                const route = await next();
                return route;
            }
        },
        // mobile version for new cda webview
        // with auth
        {
            path: '/aid/mobile',
            children: [
                {
                    name: 'host-mobile',
                    path: '/host',
                    load: ()=>import(/* webpackChunkName: 'mobile' */ './_mobile/host')
                },
                {
                    name: 'dashboard-mobile',
                    path: '/dashboard',
                    load: ()=>import(/* webpackChunkName: 'mobile' */ './_mobile/dashboard')
                },
                {
                    name: 'change-password-mobile',
                    path: '/change-password',
                    load: ()=>import(/* webpackChunkName: 'mobile' */ './_mobile/change-password')
                },
                {
                    name: 'communication-preferences-mobile',
                    path: '/communication-preferences',
                    load: ()=>import(/* webpackChunkName: 'mobile' */ './_mobile/communication-preferences')
                },
                {
                    name: 'delete-account-mobile',
                    path: '/delete-account',
                    load: ()=>import(/* webpackChunkName: 'mobile' */ './_mobile/delete-account')
                },
                {
                    name: 'diabetes-details-mobile',
                    path: '/diabetes-details',
                    load: ()=>import(/* webpackChunkName: 'mobile' */ './_mobile/diabetes-details')
                },
                {
                    name: 'last-login-mobile',
                    path: '/last-login',
                    load: ()=>import(/* webpackChunkName: 'mobile' */ './_mobile/last-login')
                },
                {
                    name: 'about-mobile',
                    path: '/about',
                    load: ()=>import(/* webpackChunkName: 'mobile' */ './_mobile/about')
                },
                {
                    name: 'terms-mobile',
                    path: '/terms',
                    load: ()=>import(/* webpackChunkName: 'mobile' */ './_mobile/terms')
                },
                {
                    name: 'privacy-policy-mobile',
                    path: '/privacy-policy',
                    load: ()=>import(/* webpackChunkName: 'mobile' */ './_mobile/privacy-policy')
                },
                {
                    name: 'reset-password-mobile',
                    path: '/manage-password',
                    load: ()=>import(/* webpackChunkName: 'mobile' */ './_mobile/change-password')
                },
                {
                    name: 'mfa-mobile',
                    path: '/mfa',
                    load: ()=>import(/* webpackChunkName: 'mobile' */ './_mobile/mfa')
                },
                {
                    name: 'set-information-mobile',
                    path: '/set-information',
                    load: ()=>import(/* webpackChunkName: 'mobile' */ './_mobile/set-information')
                },
                {
                    name: 'restore-sso',
                    path: '/restore-sso',
                    load: ()=>import(/* webpackChunkName: 'mobile' */ './_mobile/restore-sso')
                }
            ],
            async action ({ next }) {
                // Execute each child route until one of them return the result
                const route = await next();
                return route;
            }
        },
        // preferences
        {
            path: '/aid/preferences',
            children: [
                {
                    name: 'preferences',
                    path: '',
                    load: ()=>import(/* webpackChunkName: 'preferences' */ './preferences')
                },
                {
                    name: 'mfa',
                    path: '/mfa',
                    load: ()=>import(/* webpackChunkName: 'preferences' */ './mfa')
                }
            ],
            async action ({ next }) {
                // Execute each child route until one of them return the result
                const route = await next();
                return route;
            }
        },
        // organization
        {
            path: '/aid/organization',
            children: [
                {
                    name: 'organization-add',
                    path: '/create',
                    load: ()=>import(/* webpackChunkName: 'organization' */ './organization-add')
                },
                {
                    name: 'organization-choose',
                    path: '/choose',
                    load: ()=>import(/* webpackChunkName: 'organization' */ './organization-choose')
                }
            ],
            async action ({ next }) {
                // Execute each child route until one of them return the result
                const route = await next();
                return route;
            }
        },
        // open
        {
            path: '/aid',
            children: [
                {
                    name: 'auth',
                    path: '/auth',
                    load: ()=>import(/* webpackChunkName: 'account' */ './auth')
                },
                {
                    name: 'auth-error',
                    path: '/auth-error',
                    load: ()=>import(/* webpackChunkName: 'account' */ './auth')
                },
                {
                    name: 'auth-silent',
                    path: '/auth-silent',
                    load: ()=>import(/* webpackChunkName: 'account' */ './sign-in-silent')
                },
                {
                    name: 'logout',
                    path: '/logout',
                    load: ()=>import(/* webpackChunkName: 'account' */ './logout')
                },
                {
                    name: 'logout-success',
                    path: '/logout-success',
                    load: ()=>import(/* webpackChunkName: 'account' */ './logout')
                },
                {
                    name: 'sign-in',
                    path: '/sign-in',
                    load: ()=>import(/* webpackChunkName: 'account' */ './sign-in')
                },
                {
                    name: 'sign-up',
                    path: '/sign-up',
                    load: ()=>import(/* webpackChunkName: 'account' */ './sign-up')
                },
                {
                    name: 'receive-invitation',
                    path: '/receive-invitation/:invitationCountryCode/:invitationToken',
                    load: ()=>import(/* webpackChunkName: 'account' */ './receive-invitation')
                },
                {
                    name: 'reset-password',
                    path: '/reset-password',
                    load: ()=>import(/* webpackChunkName: 'reset-password' */ './reset-password')
                },
                {
                    name: 'secrets-recovery',
                    path: '/secrets-recovery',
                    load: ()=>import(/* webpackChunkName: 'secrets-recovery' */ './secrets-recovery')
                },
                {
                    name: 'confirm-email',
                    path: '/confirm-email/:countryCode/:token',
                    load: ()=>import(/* webpackChunkName: 'account' */ './confirm-email')
                },
                {
                    name: 'activate-organization',
                    path: '/activate-organization/:token',
                    load: ()=>import(/* webpackChunkName: 'administration' */ './activate-organization')
                },
                {
                    name: 'integration',
                    path: '/integration',
                    load: ()=>import(/* webpackChunkName: 'integration' */ './integration')
                },
                // {
                //   name: 'test',
                //   path: '/test',
                //   load: () => import(/* webpackChunkName: 'account' */ './test'),
                // },
                //
                //
                // {
                //   name: 'test2',
                //   path: '/test2',
                //   load: () => import(/* webpackChunkName: 'account' */ './test2'),
                // },
                //
                //
                // {
                //   name: 'test2risus',
                //   path: '/test2#risus',
                //   load: () => import(/* webpackChunkName: 'account' */ './test2'),
                // },
                {
                    name: 'error',
                    path: '/error/:code',
                    load: ()=>import(/* webpackChunkName: 'error' */ './error')
                }
            ],
            async action ({ next }) {
                // Execute each child route until one of them return the result
                const route = await next();
                return route;
            }
        },
        // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
        {
            name: 'not-found',
            path: '(.*)',
            load: ()=>import(/* webpackChunkName: 'not-found' */ './not-found')
        }
    ],
    async action ({ next }) {
        // Execute each child route until one of them return the result
        const route = await next();
        return route;
    }
};
export default routes;
